import { useEffect, useState } from "react";
import { getAll } from "../../services/slikaGalerija.service";
import Background from "../../components/Background4";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const GalerijaPageKorisnik = () => {
  const [slike, setSlike] = useState([]);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      const res = await getAll();
      setSlike(res.data);
    };
    fetch();
  }, []);

  const lightboxSlike = slike.map((s) => ({
    src: s.putanja,
  }));

  return (
    <div>
      <Background />
      <div className="galerija-container">
        <div className="galerija-zamuceni">
          <div className="galerija-slika-div">
            {slike.map((slika, i) => (
              <img
                key={slika.id}
                src={slika.putanja}
                alt={`slika-${i}`}
                className="galerija-image-style"
                onClick={() => {
                  setIndex(i);
                  setOpen(true);
                }}
              />
            ))}
          </div>

          {open && (
            <Lightbox
              open={open}
              close={() => setOpen(false)}
              index={index}
              slides={lightboxSlike}
              on={{ view: ({ index }) => setIndex(index) }}
              plugins={[Thumbnails]}
              thumbnails={{
                position: "bottom",
                width: 100,
                height: 60,
                border: 1,
                padding: 5,
                gap: 8,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default GalerijaPageKorisnik;
